// extracted by mini-css-extract-plugin
export default {"uploaded":"styles_uploaded__hjwNo","btn":"styles_btn__L35fz","textUploaded":"styles_textUploaded__sQPxN"};